import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=a938fc08&scoped=true&"
import script from "./RichTextField.vue?vue&type=script&lang=js&"
export * from "./RichTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a938fc08",
  null
  
)

export default component.exports